module.exports = __webpack_public_path__ + "img/exam2.47b03936.png";